import firebase from "firebase";
import {CreateClientData, FeClient, FsClient, UpdateClientInput, UpdateClientResult} from "./types";
import _ from "lodash";
import {replaceUndefinedWithDelete} from "../../../utils";

const clientDataConverter: firebase.firestore.FirestoreDataConverter<FeClient> = {
    fromFirestore(snapshot: firebase.firestore.QueryDocumentSnapshot<FsClient>): FeClient {
        const {createdAt, updatedAt, ...docData} = snapshot.data();
        return {
            id: snapshot.id,
            ...docData,
            createdAt: createdAt.toMillis(),
            updatedAt: updatedAt.toMillis()
        }
    },
    toFirestore({id, createdAt, updatedAt, companyName, ...docData}: FeClient): FsClient {
        return {
            ..._.pickBy(docData, _.identity) as FeClient,
            createdAt: firebase.firestore.Timestamp.fromMillis(createdAt),
            updatedAt: firebase.firestore.Timestamp.fromMillis(updatedAt),
        };
    }
}

export class ClientService {
    private static GetCollection() {
        return firebase.firestore()
            .collection('clients')
            .withConverter(clientDataConverter);
    }

    private static GetClientNumberCollection() {
        return firebase.firestore()
            .collection('clientNumber')
    }

    async createClient(dto: CreateClientData): Promise<FeClient> {

        const dateInMillis = new Date().getTime();

        const clientNumberDocSnap = await ClientService.GetClientNumberCollection().doc('counter').get();

        const clientNumberData = clientNumberDocSnap.data();

        let newClientNumber: number;

        if (!clientNumberData?.value) {
            newClientNumber = 10000;
            await ClientService.GetClientNumberCollection().doc('counter').set({value: 10000});
        } else {
            newClientNumber = (clientNumberData.value as number) + 1;
            await ClientService.GetClientNumberCollection().doc('counter')
                .update({
                    value: firebase.firestore.FieldValue.increment(1)
                });
        }

        const result = await ClientService.GetCollection().add({
            id: '',
            ...dto,
            clientNumber: newClientNumber,
            createdAt: dateInMillis,
            updatedAt: dateInMillis,
        });

        return {
            ...dto,
            id: result.id,
            clientNumber: newClientNumber,
            createdAt: dateInMillis,
            updatedAt: dateInMillis,
        }
    }

    async updateClient(id: string, dto: UpdateClientInput): Promise<UpdateClientResult> {
        await ClientService.GetCollection().doc(id).update({
            ...replaceUndefinedWithDelete(dto),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        });
        return {
            id,
            updatedAt: new Date().getTime(),
            ...dto,
        }
    }

    async listClients(): Promise<FeClient[]> {
        const querySnapshots = await ClientService.GetCollection().get();
        return querySnapshots.empty
            ? []
            : querySnapshots.docs.map(d => d.data())
    }

    async getClient(id: string): Promise<FeClient> {
        const snapshot = await ClientService.GetCollection().doc(id).get();
        const worker = snapshot.data();
        if (!worker) {
            throw new Error('Client not found');
        }
        return worker;
    }
}